export const RAG_LOADING_MESSAGES: string[] = [
  "Got it - interpreting your question…",
  "Searching trusted content and preparing your answer…",
  "Thanks for your patience - nearly there…",
];

export const RAG_LOADING_MESSAGES_INTERVAL = 2000;
